<template>
  <div class="animated fadeIn">
    <router-link :to="'os/' + os.nr_sequencial" class="small-box" style="cursor: pointer;">
      <div class="inner text-white bg-dark" :style="bgCard">
        <div class="row" style="justify-content: space-between;">
          <div class="col-md-4 col-3 text-left ">
            <span class="badge float-left mt-1" :class="bgColor">
              {{
                getHorasPrev(os.criticidade.ds_criticidade)
              }}
            </span>
          </div>

          <div class="col-md-8 col-7 text-right text-center-sm text-18">
            {{ os.dt_os | formatDate("DD/MM/YYYY HH:mm") }}
          </div>
        </div>
        <hr v-if="cardEmAtendimento || this.os.st_os_pause == 'P'">
        <div class="row align-items-center">
          <div class="col-md-1 col-1 ml-3 mr-4">
            <span style="margin-right: 10px;" class="badge spanAtendimento">
              <i class="fas fa-user" v-if="cardEmAtendimento"></i>
            </span>
          </div>
          <small v-if="cardEmAtendimento">
            {{ this.os.ds_mecanico ? (this.os.ds_mecanico.length > 20 ? this.os.ds_mecanico.slice(0, 20) + '...' :
            this.os.ds_mecanico) : '' }}
          </small>
          <div class="col-md-1 col-1" v-if="this.os.st_os == 'L'">
            <span class="badge spanAtendimento" style="background: rgb(236 111 0) !important;  padding: 8px!important">
              <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-forklift m-0 p-0" width="20"
                height="20" viewBox="0 0 24 24" stroke-width="2" stroke="white" fill="none" stroke-linecap="round"
                stroke-linejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <circle cx="5" cy="17" r="2" />
                <circle cx="14" cy="17" r="2" />
                <line x1="7" y1="17" x2="12" y2="17" />
                <path d="M3 17v-6h13v6" />
                <path d="M5 11v-4h4" />
                <path d="M9 11v-6h4l3 6" />
                <path d="M22 15h-3v-10" />
                <line x1="16" y1="13" x2="19" y2="13" />
              </svg>
            </span>
          </div>
          <div class="col-md-1 col-1" v-if="this.os.st_os_pause == 'P'">
            <span class="badge spanAtendimento" style="background: rgb(255 191 0) !important; color: #000;">
              <i class="fa fa-pause" aria-hidden="true"></i>
            </span>
          </div>
        </div>

        <div class="text-center mt-3">
          <h4>
            <small><i class="fas fa-hashtag"></i></small> {{ os.nr_sequencial }}
          </h4>
          <h4 v-if="this.os.location == 'M' || this.os.exibe_numero_frota">
            <small><i class="fa fa-truck" aria-hidden="true"></i></small> {{ os.nr_frota }}
          </h4>
          <h3>{{ os.nr_placa }}</h3>

          <p class="text-lg">
            <span>{{ os.ds_tipo }}</span>
          </p>

          <div class="mb-3">
            <span class="font-weight-light text-18" v-if="!isComplete">
              <i class="fas fa-clock"></i> {{ $t('Aberta há') }} <br /><span class="font-weight-normal">
                {{ openTime }}
              </span>
            </span>
            <span class="font-weight-light text-18" v-if="isComplete">
              <i class="fas fa-check"></i> {{ $t('Concluída em') }} <br /><span class="font-weight-bold">
                {{ openTime }}
              </span>
            </span>
          </div>

          <div class="mb-3 font-weight-light col-12">
            <div class="row osTimeWrapper">
              <div v-show="this.os.ds_conjunto" class="col-sm-12 ">
                <p class="conjuntos">{{ this.os.ds_grupo }} | {{ this.os.ds_conjunto }}</p>
              </div>
            </div>
          </div>
          <div class="mb-3 font-weight-light col-12" v-if="this.os.hr_sla || this.os.nr_seq_tipo == 'V'">
            <div class="row osTimeWrapper">
              <div class="col-sm-12 ">
                <p v-if="this.os.nr_seq_tipo != 'V'" class="conjuntos">SLA: {{ this.os.hr_sla }}</p>
                <p v-if="this.os.nr_seq_tipo == 'V'" class="conjuntos">SLA: 72:00</p>
              </div>
            </div>
          </div>
          <div class="mb-3 font-weight-light col-12" v-if="this.os.ds_tipo == 'PREVENTIVA'">
            <div class="row osTimeWrapper">
              <div class="col-sm-12 ">
                <p class="conjuntos">Ciclo: {{ this.os.ds_ciclo }}</p>
              </div>
            </div>
          </div>
          <div class="mb-3 font-weight-light col-12" v-if="this.os.st_origem == 'E'">
            <div class="row osTimeWrapper">
              <div class="col-sm-12 ">
                <p class="conjuntos">Fornecedor: {{ this.os.ds_fornecedor.substring(0.8) }}</p>
              </div>
            </div>
          </div>
          <div class="mb-3 font-weight-light col-12"
            v-if="this.os.st_os == 'R' && this.os.executaveis_encerrados.length > 0 && this.os.st_origem != 'E'">
            <div class="row osTimeWrapper"
              v-if="this.os.executaveis_encerrados[0].execucao_final.tecnico_final != null">
              <div class="col-sm-12 ">
                <p class="conjuntos">Mecânico: {{
                  this.os.executaveis_encerrados[0].execucao_final.tecnico_final.ds_colaborador.substring(0.8)
                  }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <a class="small-box-footer text-lg" :class="bgColor">
        {{ this.$t('Detalhes') }} <i class="fas fa-arrow-circle-right"></i>
      </a>
    </router-link>
  </div>
</template>

<script>
import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)

export default {
  props: {
    os: {}
  },

  data() {
    return {
      openTime: 0,
      executaveis: {
        total: 0,
        finalizados: 0
      },
      show: false,
    }
  },
 
  computed: {
    cardEmAtendimento() {
      if (this.os.tp_os == 'V') {
        if (this.os.dt_inicial !== null && this.os.dt_final === null) {
          return true
        }

        return false

      } else {
        if (this.os.execucao_inicio != null & this.os.execucao_final === null) {
          return true
        }

        return false
      }


    },

    bgCard() {
      const defaultColor = 'bg-light'

      if (this.isComplete) {
        return 'background-image: linear-gradient(45deg, rgb(16 71 29), rgb(41 167 70)) !important;'
      }
      if (this.os.nr_seq_tipo == "V" || this.os.nr_seq_tipo == "R") {
        return 'background-image: linear-gradient(45deg, rgb(67 73 75), rgb(174 179 181)) !important;'
      } 
      
      // console.log(this.os.criticidade)
      if (this.os.criticidade) {
        switch (this.os.criticidade.nr_nivel) {
          case 0:
          // IMEDIATA
          return 'background-image: linear-gradient(45deg, #8f2326, #f03035) !important;'
        case 1:
          // EMERGENCIAL
          return 'background-image: linear-gradient(45deg, #b14e00, #f38833) !important;'
        case 2:
          // 24 HORAS
          return 'background-image: linear-gradient(45deg, #bd8e00, #fbc110) !important;'
        case 3:
          // 4 HORAS (HORÁRIO COMERCIAL)
          return 'background-image: linear-gradient(45deg, #028b4c, #00a65a) !important;'
          // return 'background-image: linear-gradient(45deg, #00aff1, #00aff1);'
        case 4:
          // 48 HORAS
          return 'background-image: linear-gradient(45deg, #00aff1, #00aff1);'
          // return 'background-image: linear-gradient(45deg, #028b4c, #00a65a) !important;'
          
          default:
            return defaultColor
        }
      }

      

      return defaultColor
    },
    bgColor() {
      const defaultColor = 'bg-light'

      if (this.isComplete) {
        return 'bg-success'
      }

      if (this.os.criticidade) {
        switch (this.os.criticidade.nr_nivel) {
          case 0:
            return 'bg-danger'
          case 1:
            return 'bg-orange'
          case 2:
            return 'bg-yellow'
          case 3:
            return 'bg-green'
          case 4:
            return 'bg-blue'

          default:
            return defaultColor
        }
      }

      return defaultColor
    },
    isComplete() {
      return (
        this.executaveis.total > 0 &&
        this.executaveis.total === this.executaveis.finalizados
      )
    }
  },

  mounted() {
    this.countExecutaveis()
    this.countExecutaveisEncerrados()
    this.getOpenTime()
  },

  methods: {
    getHorasPrev(ds_criticidade) {
      if(typeof ds_criticidade == 'string') return ds_criticidade

      let valor = ''
      const json_bruto = localStorage.getItem('filial')
      const json = JSON.parse(json_bruto, true)

      console.log(json)
      if(json.location == null) return '24 HORAS'

      return '72 HORAS'
    },
 
    countExecutaveis() {
      if (this.os.executaveis) {
        this.executaveis.total = this.os.executaveis.length
      }
    },
    countExecutaveisEncerrados() {
      if (this.executaveis.total > 0) {
        this.executaveis.finalizados = this.os.executaveis_encerrados.length
      }
    },
    getOpenTime() {
      var inicio = moment(new Date(this.os.dt_os))

      var final = moment(new Date())
      if (this.isComplete && this.os.dt_final) {
        final = moment(new Date(this.os.dt_final))
      }

      // if (this.os.hr_fuso == -1) {
      //   final = final.subtract(1, 'hours');
      // } 

      var duration = moment
        .duration(final.diff(inicio))
        .format('d [d] h[h]mm[m]')

      this.openTime = duration

      if (!this.isComplete) {
        setTimeout(this.getOpenTime, 60000)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .spanAtendimento {
    background: #287b21;
    padding: 10px;
    font-size: 13px;
    border-radius: 50%;

    box-shadow: 0px 0px 5px -2px #000;
  }

  .conjuntos {
    font-size: 17px;
    margin-bottom: 0px;
    font-weight: 500;
  }

  .os-items-wrapper {
    height: 285px;
  }

  .icon--custom {
    top: 50px !important;
  }

  .osTimeWrapper {
    @media only screen and (min-width: 1200px) and (max-width: 1366px) {
      height: 72px;
    }
  }
</style>
